<template>
    <div>
        <v-dialog v-model="dialog" max-width="450px" persistent @keydown.esc="$emit('close')" @click:outside="$emit('close')" aria-modal="true" :aria-labelledby="titleId" :aria-describedby="descId">
            <v-card v-focus-trap="dialog">
                <v-card-title :id="titleId" class="text-h6">
                    <span class="mr-2">Delete {{ deleteLabel }}</span>
                    <span class="no-line-break" v-if="displaySelected">
                        <strong class="px-0 mx-0">“{{ displaySelected }}”</strong>
                    </span>
                </v-card-title>

                <!-- Optionaler Hinweis, z.B. welche Credits die Löschung freigibt -->
                <v-card-text v-if="hint" class="pb-0" style="font-size: 13px">
                    <v-icon x-small class="mr-1">mdi-database-outline</v-icon>
                    {{ hint }}
                </v-card-text>

                <!-- Screenreader-Only Beschreibung -->
                <v-card-text :id="descId" class="sr-only"> This action cannot be undone. Press Cancel to abort or Delete to confirm. </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-btn ref="cancelBtn" data-focus-first class="mr-3" text rounded type="button" @click="$emit('close')"> Cancel </v-btn>

                    <v-btn :loading="loading" :aria-busy="loading ? 'true' : 'false'" rounded class="ml-auto" color="error" type="button" @click="$emit('delete')"> Delete </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "DeleteDialog",
        props: {
            deleteDialog: { type: Boolean, default: false },
            selectedDeleteItem: { type: String, default: "" },
            deleteLabel: { type: String, default: "item" },
            loading: { type: Boolean, default: false },
            // optionaler sichtbarer Hinweis unter dem Titel; ohne Angabe bleibt der Dialog wie bisher
            hint: { type: String, default: "" }
        },
        computed: {
            dialog: {
                get() {
                    return this.deleteDialog
                },
                set() {
                    // any external close (overlay/esc) emits up
                    this.$emit("close")
                }
            },
            displaySelected() {
                return (this.selectedDeleteItem || "").trim()
            },
            titleId() {
                return "delete-dialog-title"
            },
            descId() {
                return "delete-dialog-desc"
            }
        },
        watch: {
            deleteDialog(val) {
                if (val) {
                    // Fokus sicher auf "Cancel" setzen, sobald Dialog gerendert
                    this.$nextTick(() => {
                        this.$refs.cancelBtn && this.$refs.cancelBtn.$el && this.$refs.cancelBtn.$el.focus()
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .sr-only {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
    }
</style>
